import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "change-replace",
  "use": "change-replace-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"change-replace\"><path fill-rule=\"evenodd\" d=\"m15 12 4 4 4-4h-3c0-4.42-3.58-8-8-8-1.57 0-3.03.46-4.26 1.24L9.2 6.7c.83-.45 1.79-.7 2.8-.7 3.31 0 6 2.69 6 6h-3Zm-.2 5.3c-.84.44-1.79.7-2.8.7-3.31 0-6-2.69-6-6h3L5 8l-4 4h3c0 4.42 3.58 8 8 8 1.57 0 3.03-.46 4.26-1.24L14.8 17.3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol